import React from 'react';
import { useGoalChartQuery } from '../../../api/useGoalChartQuery';
import { useChartReflow } from './useChartReflow';
import LoadingChart from '../../../../CommonComponents/LoadingChart';
import { ErrorState } from '../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { RetirementChart } from '../../../../FinancialPlanOPL/Goals/goals/Retirement/components/RetirementChart/RetirementChart';
import { LegendKey } from '../../../../CommonComponents/OPL/charts/LegendKey/LegendKey';

interface Props {
  clientId: string;
  proposedPlan: string;
  fpId: string;
  isCurrentPlan: boolean;
  title: string;
}

export const Retirement = ({ clientId, proposedPlan, fpId, isCurrentPlan, title }: Props) => {
  const { isLoading, isError, refetch, data } = useGoalChartQuery({ clientId, fpId });

  const { chartRef } = useChartReflow();

  if (isLoading) {
    return (
      <Box p="48">
        <LoadingChart />
      </Box>
    );
  }

  if (isError) {
    return <ErrorState onAction={refetch} mt="48" />;
  }

  if (!data) {
    return null;
  }

  return (
    <div className="opl-chart">
      {!isCurrentPlan && (
        <Box display="flex" justifyContent="space-between" className="hide-on-mobile-screens">
          <h4>{title}</h4>

          <Box display="flex" justifyContent="center">
            <LegendKey
              text="Current"
              tooltipContent={ADV.tooltip_callouts.RetirementAssetsChart.Current.html}
              tooltipPlacement={ADV.tooltip_callouts.RetirementAssetsChart.Current.orientation}
            />
            <LegendKey
              dotBorderColor="primary.500"
              dotColor="primary.100"
              isTextTruncated
              ml="24"
              text={proposedPlan}
              tooltipContent={ADV.tooltip_callouts.RetirementAssetsChart.ProposedPlanOverview.html}
              tooltipPlacement={
                ADV.tooltip_callouts.RetirementAssetsChart.ProposedPlanOverview.orientation
              }
            />
          </Box>
        </Box>
      )}

      <RetirementChart ref={chartRef} data={data.GoalChart.Chart} isCurrentPlan={isCurrentPlan} />
    </div>
  );
};
